export enum AppflowEnvEnum {
  LOCAL = 'Local',
  STAGING = 'Staging',
  PRODUCTION = 'Production'
}